var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgTelegram = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 35,
  height: 35,
  viewBox: "0 0 35 35",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M31.7726 3.18411L2.5409 14.5883C0.545956 15.399 0.557497 16.5249 2.17488 17.0269L9.67982 19.3955L27.044 8.31158C27.8651 7.80617 28.6153 8.07806 27.9986 8.63184L13.9302 21.4772H13.9269L13.9302 21.4789L13.4125 29.3052C14.1709 29.3052 14.5056 28.9532 14.931 28.5379L18.5763 24.9517L26.1587 30.6179C27.5568 31.3969 28.5609 30.9966 28.9087 29.3085L33.8862 5.57604C34.3957 3.50937 33.1064 2.57361 31.7726 3.18411Z",
  fill: "white"
})));
export { SvgTelegram as ReactComponent };
export default __webpack_public_path__ + "assets/icons/telegram.ab4418.svg";